import useFetch from "../../Hooks/useFetch";
import styles from "./assets/css/PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  const { data } = useFetch("pages/408");
  document.body.style = "background-color: #fff";
  return (
    <section className={styles.privacyPolicySection}>
      {data && (
        <>
          <h1>{data.title.rendered}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: data ? data.content.rendered : "",
            }}
          ></div>
        </>
      )}
    </section>
  );
};

export default PrivacyPolicy;
